/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Container, BoxUpload, BoxUploadLogo, BoxSendButton } from './styles';

export default function BoxUploadComponent({ setLogo, urlLogo }) {
  const [file, setFile] = useState();
  const [imagePreviewUrl, setImagePreviewUrl] = useState();

  const { roles } = useSelector(state => state.auth);

  const ROLE_USER = roles.includes('ROLE_USER');

  const changeLogo = event => {
    setLogo(event);
    setFile(event.target.files[0]);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreviewUrl(reader.result);
    };
    reader.readAsDataURL(event.target.files[0]);
  };

  return (
    <Container>
      {imagePreviewUrl || urlLogo ? (
        <BoxUploadLogo urlLogo={urlLogo} ROLE_USER={ROLE_USER}>
          <div className="BoxUploadLogoBox">
            <img src={imagePreviewUrl || urlLogo} alt="Logo" />
            <label htmlFor="perfilUpload">
              <input
                type="file"
                accept="image/jpeg, image/png"
                id="perfilUpload"
                onChange={event => {
                  changeLogo(event);
                }}
              />
            </label>
            {file && (
              <span className="fileUploadText">
                <b>Imagem selecionada:</b> {file.name}
                <br />
              </span>
            )}
            {!ROLE_USER && (
              <BoxSendButton>
                <button type="button">Enviar novo arquivo</button>
              </BoxSendButton>
            )}
          </div>
        </BoxUploadLogo>
      ) : (
        <BoxUpload id="BoxUpload">
          <div className="formContainer" id="fileUploadForm">
            <label htmlFor="perfilUpload">
              <input
                type="file"
                accept="image/jpeg, image/png"
                id="perfilUpload"
                onChange={e => {
                  changeLogo(e);
                }}
              />
            </label>

            {file ? (
              <span className="fileUploadText">
                <b>Imagem selecionada:</b> {file.name}
                <br />
              </span>
            ) : (
              <span className="fileUploadText">
                Busque o arquivo para <br /> fazer upload.
                <br />
              </span>
            )}

            <BoxSendButton>
              <button type="button">Enviar novo arquivo</button>
            </BoxSendButton>
          </div>
        </BoxUpload>
      )}
    </Container>
  );
}
